require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-new-starter-app-launches-react-projects-fast.json") })
        }
      }, "path---blog-new-starter-app-launches-react-projects-fast");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-new-starter-app-launches-react-projects-fast!./.cache/json/blog-new-starter-app-launches-react-projects-fast.json
// module id = 1018
// module chunks = 231608221292675